import { Timezone } from "@/types/timezone"
import { Country } from "@/types/country"
import { PricingPlanType } from "@/store/pricing-plans/types"

export const STORE_NAME = "timeOfUsePlans"

export enum LoadingTypes {
    GLOBAL = "GLOBAL",
    TIMEPLAN_LIST = "TIMEPLAN_LIST",
    TIMEZONE_LIST = "TIMEZONE_LIST",
    COUNTRY_LIST = "COUNTRY_LIST",
    BLOCK_LIST = "BLOCK_LIST",
    SEASON_LIST = "SEASON_LIST",
    TIMESLOT_LIST = "TIMESLOT_LIST",
    POST_BLOCK = "POST_BLOCK",
    POST_SEASON = "POST_SEASON",
    POST_TIMESLOT = "POST_TIMESLOT",
    TIMEPLAN_STRUCTURE = "TIMEPLAN_STRUCTURE",
}

// export enum TimePlanTypes {
//     PRICING_ENERGY = "PRICING_ENERGY", //UTILITY Supplier energy buy & Supplier energy sell => PRICING ENERGY
//     PRICING_NETWORK_ENERGY = "PRICING_NETWORK_ENERGY", //NETWORK Distributor energy price
//     PRICING_NETWORK_POWER = "PRICING_NETWORK_POWER", //NETWORK Distributor power price
//     LIMIT_POWER = "LIMIT_POWER",
// }
//
// export const PlanTypes: Record<TimePlanTypes, string> = {
//     [TimePlanTypes.PRICING_ENERGY]: "Pricing Energy",
//     [TimePlanTypes.PRICING_NETWORK_ENERGY]: "Pricing Network Energy",
//     [TimePlanTypes.PRICING_NETWORK_POWER]: "Pricing Network Power",
//     [TimePlanTypes.LIMIT_POWER]: "Limit Power",
// }

export type CommonApiDto<T> = {
    data: T
}

export type TimezonesApiResponse = CommonApiDto<{
    timezones: Timezone[]
}>

export type TimeplansApiResponse = CommonApiDto<{
    data: TimePlan[]
}>

export type SeasonApiResponse = CommonApiDto<{
    data: Season[]
}>

export type BlocksApiResponse = CommonApiDto<{
    data: Block[]
}>

export type CountriesApiResponse = CommonApiDto<{
    countries: Country[]
}>

export type TimeslotApiResponse = CommonApiDto<{
    data: Timeslot[]
}>

export type TimePlan = {
    id: number
    title: string
    planTypes: PricingPlanType[]
    timezone: string
    countryId: number
    validFrom?: string
    validUntil?: string
    country: Country
    owner: {
        id: number
        fullName: string
        email: string
    } | null
    company: {
        id: number
        name: string
        country: Country
    }
}

export type CreateTimePlan = Omit<TimePlan, "id" | "country"> & { countryId: number }
export type PutTimePlan = Partial<TimePlan>

export type Block = {
    id: number
    title: string
    color: string
}

export type Season = {
    id: number
    title: string
    months: number[]
}

export type Timeslot = {
    id: number
    validFrom: string
    validUntil: string
    dayOfWeek: number
    seasonId: number
}

export type CreateSeason = Omit<Season, "id">

export type CreateBlock = Omit<Block, "id">

export type CreateTimeslot = Omit<Timeslot, "id">

export type NewItem = {
    isNew: boolean
    shouldDelete: boolean
}

export type TimeplanStructureSlot = Timeslot & {
    season: Season
}

export type TimeplanStructureBlock = Block & {
    slots: TimeplanStructureSlot[]
}

export type TimeplanStructure = {
    blocks: TimeplanStructureBlock[]
}

export enum TimeOfUseMutations {
    SET_LOADING = "setLoading",
    SET_TIMEZONE_LIST = "setTimezoneList",
    SET_TIMEPLAN_LIST = "setTimeplanList",
    SET_COUNTRY_LIST = "setCountryList",
    SET_BLOCK_LIST = "setBlockList",
    SET_SEASON_LIST = "setSeasonList",
    SET_TIMESLOT_LIST = "setTimeslotList",
    SET_NEW_TIMEPLAN = "setNewTimeplan",
    SET_SELECTED_TIMEPLAN = "setSelectedTimeplan",
    SET_TIMEPLAN_STRUCTURE = "setTimeplanStructure",
}

export const TimeOfUseActions = {
    FETCH_TIMEZONE_LIST: `${STORE_NAME}/fetchTimezones`,
    FETCH_TIMEPLAN_LIST: `${STORE_NAME}/fetchTimeplans`,
    FETCH_TIMEPLAN: `${STORE_NAME}/fetchTimeplan`,
    FETCH_COUNTRY_TIMEPLAN_LIST: `${STORE_NAME}/fetchTimeplansByCountry`,
    DELETE_TIMEPLAN: `${STORE_NAME}/deleteTimeplan`,
    FETCH_BLOCK_LIST: `${STORE_NAME}/fetchBlocks`,
    POST_TIME_PLAN: `${STORE_NAME}/postTimePlan`,
    PUT_TIME_PLAN: `${STORE_NAME}/putTimePlan`,
    FETCH_COUNTRY_LIST: `${STORE_NAME}/fetchCountryList`,
    POST_BLOCK: `${STORE_NAME}/postBlock`,
    PUT_BLOCK: `${STORE_NAME}/putBlock`,
    DELETE_BLOCK: `${STORE_NAME}/deleteBlock`,
    FETCH_SEASON_LIST: `${STORE_NAME}/fetchSeasons`,
    POST_SEASON: `${STORE_NAME}/postSeason`,
    PUT_SEASON: `${STORE_NAME}/putSeason`,
    DELETE_SEASON: `${STORE_NAME}/deleteSeason`,
    FETCH_TIMESLOT_LIST_BY_BLOCK_ID: `${STORE_NAME}/fetchTimeslotsByBlockId`,
    FETCH_TIMESLOT_LIST_BY_TIMEPLAN_ID: `${STORE_NAME}/fetchTimeslotsByTimeplanId`,
    FETCH_TIMEPLAN_STRUCTURE: `${STORE_NAME}/fetchTimeplanStructure`,
    POST_TIME_SLOT: `${STORE_NAME}/postTimeslot`,
    PUT_TIME_SLOT: `${STORE_NAME}/putTimeslot`,
    DELETE_TIME_SLOT: `${STORE_NAME}/deleteTimeslot`,
} as const

export type TimeOfUseState = {
    timeplanList: []
    timezoneList: Timezone[]
    countryList: Country[]
    blockList: Block[]
    seasonList: Season[]
    timeslotList: Timeslot[]
    newTimeplan: TimePlan | null
    loading: Record<LoadingTypes, boolean>
    selectedTimeplan: TimePlan | null
    timeplanStructure: TimeplanStructure | null
}

//months
export const SeasonsMap: Record<number, string> = {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December",
}

export const DaysMap: Record<number, string> = {
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
    7: "Sunday",
}

export type SlotItem = {
    id: number
    start: string
    end: string
    color: string
    label: string
    blockId: number | null
    isNew: boolean
    shouldDelete: boolean
    isDirty: boolean
}
